import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";

import CheckupInfo from "./checkupInfo";

import { Asset } from "../../../../models/asset";

interface IToScheduleProps {
    asset: Asset;
    hasMetrics?: boolean;
}
const NextScheduling = ({ asset, hasMetrics }: IToScheduleProps) => {
    const intl = useIntl();
    const navigate = useNavigate();

    const availableToSchedule = !asset.schedulings?.next?.[0]?.date && asset?.schedulings?.next?.[0]?.checkup?.name && !asset.schedulings?.next?.[0]?.maintenanceStatus;
    const scheduled = asset.schedulings?.next?.[0]?.date && !asset.schedulings?.next?.[0]?.maintenanceStatus;
    const inMaintenance = asset.schedulings?.next?.[0]?.maintenanceStatus && asset.schedulings?.next?.[0]?.maintenanceStatus !== 'FINISHED';
    
    const getNextSchedulingKm = () => {
        const nextScheduling = asset.schedulings?.next?.[0];
        let kmDiff = !nextScheduling?.checkup?.odometer || !asset.odometer ? 0 : nextScheduling.checkup.odometer - asset.odometer;
        
        return (
            <span className={`text-size-10 ${kmDiff >= 0 ? "text-color-primary" : "text-color-danger"}`}>
                {kmDiff > 0 ? `${kmDiff.toLocaleString("pt-BR")} ${intl.formatMessage({ id: "intl-msg:nextScheduling.kmToNextReview" })}` : ''}
                {kmDiff < 0 ? `${(-1 * kmDiff).toLocaleString("pt-BR")} ${intl.formatMessage({ id: "intl-msg:nextScheduling.kmDelayed" })}` : ''}
            </span>
        );
    }

    return (
        <>
            {scheduled || inMaintenance || (hasMetrics && availableToSchedule) ?
                <div className="flex items-center justify-between padding-bottom-0">
                    <span className="truncate">
                        {asset?.schedulings?.next?.[0]?.checkup?.name || ''}
                    </span>
                    {asset?.schedulings?.next?.[0] ? <CheckupInfo scheduling={asset?.schedulings?.next?.[0]} /> : null}
                </div> : null
            }
            
            {hasMetrics && availableToSchedule && asset.chassis !== '-' ?
                <span
                    className="text-color-success cursor-pointer"
                    onClick={() => navigate(`/fleet-manager/appointments/appointment?asset=${asset.id}&chassis=${asset.chassis}&name=${asset.name || asset.model}`)}
                >
                    {intl.formatMessage({ id: "intl-msg:nextScheduling.availableToSchedule" })}<br />
                    {getNextSchedulingKm()}
                </span> : null
            }
            
            {scheduled ?
                <span>
                    {intl.formatMessage({ id: "intl-msg:nextScheduling.scheduledFor" })} {asset.schedulings?.next?.[0]?.date?.toLocaleDateString("pt-BR")}<br />
                    {getNextSchedulingKm()}
                </span> : null
            }
            
            {inMaintenance ? <span>{intl.formatMessage({ id: "intl-msg:nextScheduling.inMaintenance" })}</span> : null}
        </>
    )
}

export default NextScheduling;